export default __webpack_public_path__ + "static/media/ic_laos_flag.850c160e.svg";